import React, { useState } from "react";
import { Modal } from "../../../../UI toolkit/Modal/Modal";
import { NGNWithdrawalOtpModalStyle } from "./NGNWithdrawal.styled";
import { H6, P } from "../../../../UI toolkit/Text/Text";
import times_solid from "../../../../assets/images/times-solid.svg";
import { DefaultButton } from "../../../../UI toolkit/Button/Button";
import { withTheme } from "styled-components";
import OTPInput from "./OTPInput.js";

const OTPConfirmationModal = ({
  width,
  theme,
  border,
  closeModalCallback,
  user,
  handleSubmit,
  handleResendOtp,
}) => {
  const [otp, setOtp] = useState("");

  const handleOtpChange = (value) => {
    setOtp(value);
  };
  return (
    <div>
      <Modal width={width} border={border} callback={closeModalCallback}>
        <NGNWithdrawalOtpModalStyle>
          <div className="-mx-8">
            <div className="flex items-center justify-between px-6 py-3 border-bottom bg-white">
              <div className="flex items-center">
                &nbsp;
                <div>
                  <H6
                    color={"#646A86"}
                    className="text-center"
                    fontWeight="700"
                  >
                    Enter OTP for confirmation
                  </H6>
                </div>
              </div>

              <div className="flex">
                <div>
                  <img
                    src={times_solid}
                    alt="cancel"
                    style={{
                      height: "15px",
                      width: "15px",
                      cursor: "pointer",
                    }}
                    onClick={closeModalCallback}
                  />
                </div>
              </div>
            </div>

            <div
              className="px-6 py-7"
              style={{ maxHeight: "80vh", overflow: "auto" }}
            >
              <div>
                <p
                  style={{
                    color: "#7A809B",
                  }}
                >
                  Enter the 6-digit confirmation code
                </p>
                <div className=" mb-6 mt-4">
                  <OTPInput onChange={handleOtpChange} />
                  {/* <p>Entered OTP: {otp}</p> */}
                </div>
                <div className="flex justify-between">
                  <DefaultButton
                    bg={"white"}
                    color={theme.colors.bg}
                    p={"8px 16px"}
                    onClick={handleResendOtp}
                  >
                    Resend code
                  </DefaultButton>
                  <DefaultButton
                    bg={theme.colors.bg}
                    color={theme.colors.color}
                    p={"8px 16px"}
                    onClick={() => handleSubmit(otp)}
                  >
                    Continue
                  </DefaultButton>
                </div>
              </div>
            </div>
          </div>
        </NGNWithdrawalOtpModalStyle>
      </Modal>
    </div>
  );
};

export default withTheme(OTPConfirmationModal);
